<template>
  <div>
    <TaoCanBo isView isEdit/>
  </div>
</template>

<script>
import TaoCanBo from "./TaoCanBo";

export default {
  name: "XemCanBo",
  components: {
    TaoCanBo,
  },
};
</script>
